module.exports = __webpack_public_path__ + "img/36.802a6c6c.jpg";